module.exports = __webpack_public_path__ + "static/media/c-french.95be8032.jpg";